import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import Vant from 'vant';

import 'vant/lib/index.css';
import 'normalize.css/normalize.css'
import 'mint-ui/lib/style.css'
import './styles/reset.css'
import './styles/style.less'

import './utils/utils.js'


import './styles/iconfont.js'
import { Dialog } from 'vant';
import { Toast } from 'vant';
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.use(MintUI)
Vue.use(Vant);
Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
import JSEncrypt from 'jsencrypt'
Vue.prototype.$getRsaCode = function(str) { // 注册加密方法
  const encryptStr = new JSEncrypt()
  const pubKey=`-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCWEjxlejRtv5IaeLevgfSO4Gy
  FrGlXvbuKJ30cUVh6gsuCcpRcqhi8/Ha2U7MACMm6hqW+LmfHXfbqp124ci6Dm7e
  4rVnkHR2oa4IGSuNOvrgVZMqBGk6BSlxH33c2lMNh8YCUixVeHq7PC0qXwE3AVZg
  z23W70BsDvwSPKPwuwIDAQAB
  -----END PUBLIC KEY-----`
  encryptStr.setPublicKey(pubKey) // 设置 加密公钥
  const data = encryptStr.encrypt(str.toString()) // 进行加密
  return data
}

Vue.prototype.$getRsaCode = function(str) { // 注册加密方法
    const encryptStr = new JSEncrypt()
    const pubKey=`-----BEGIN PUBLIC KEY-----
    MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCWEjxlejRtv5IaeLevgfSO4Gy
    FrGlXvbuKJ30cUVh6gsuCcpRcqhi8/Ha2U7MACMm6hqW+LmfHXfbqp124ci6Dm7e
    4rVnkHR2oa4IGSuNOvrgVZMqBGk6BSlxH33c2lMNh8YCUixVeHq7PC0qXwE3AVZg
    z23W70BsDvwSPKPwuwIDAQAB
    -----END PUBLIC KEY-----`
    encryptStr.setPublicKey(pubKey) // 设置 加密公钥
    const data = encryptStr.encrypt(str.toString()) // 进行加密
    return data
}
Vue.prototype.$getRsaDeCode = function(str) { // 解密
  var decrypt = new JSEncrypt()
  const pubKeyPrivate = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDCWEjxlejRtv5IaeLevgfSO4Gy
  FrGlXvbuKJ30cUVh6gsuCcpRcqhi8/Ha2U7MACMm6hqW+LmfHXfbqp124ci6Dm7e
  4rVnkHR2oa4IGSuNOvrgVZMqBGk6BSlxH33c2lMNh8YCUixVeHq7PC0qXwE3AVZg
  z23W70BsDvwSPKPwuwIDAQAB
  -----END PUBLIC KEY-----`// ES6 模板字符串 引用 rsa 公钥
  decrypt.setPrivateKey(pubKeyPrivate)//解密公钥
  var decryptMsg = decrypt.decrypt(str.toString()) //解密
  return decryptMsg
}

new Vue({
  router,
  store,
  render: h => h(App),
  created(){
    router.beforeEach((to, from, next) => {
      if(to.meta.title) {
        document.title = to.meta.title
      }
      if( (from.path == '/user' || from.path == '/user/bindPhone') && to.path == '/user/home'){

      }
      next();
    })

    router.afterEach( ( to, from, next ) => {
      setTimeout(()=>{
                var _hmt = _hmt || [];
                (function() {
                    //每次执行前，先移除上次插入的代码
                    document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
                    var hm = document.createElement("script");
                    hm.src = "https://hm.baidu.com/hm.js?bd26361b4905ce3a2715c7b9504ad9b8";
                    hm.id = "baidu_tj"

                    //聚量广告
                    var jl = document.createElement("script");
                    jl.src = "https://static.lejuliang.com/lejuliangjsapiv2.min.js";
                    jl.id = "jlAdvertis"

                    var s = document.getElementsByTagName("script")[0];
                    s.parentNode.insertBefore(hm, s);
                    s.parentNode.insertBefore(jl, s);

                    if(_hmt){
                      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
                      console.info("push path"+'/#' + to.fullPath + " end");
                    }
                })();
        },0);
    } );

  },
  mounted () {
    this.$store.state.iccid = localStorage.getItem('iccid');
  }
}).$mount('#app')
